import { logError, logWarn } from 'lib/logging'

export type boomTypes =
  | `badRequest`
  | `badImplementation`
  | `unauthorized`
  | `forbidden`
  | `notFound`
  | `expectationFailed`

/**
 * assert that the predicate is true. if it is not, throw an error
 */
export function assertBoom(predicate: unknown, message?: string, boomType: boomTypes = `notFound`): asserts predicate {
  if (!predicate) {
    const err = new Error(message || boomType)
    if (boomType === `unauthorized`) {
      logError(`[auth error]`, err)
    } else if (boomType === `badImplementation`) {
      logError(`[server error]`, err)
    }
    throw err
  }
}

// throws badRequest
export function assertGood(predicate: unknown, ...message: any): asserts predicate {
  assertBoom(predicate, message?.map((i: unknown) => String(i)).join(` `) || `bad request`, `badRequest`)
}

// throws unauthorized
export function assertAllowed(predicate: unknown, ...message: any): asserts predicate {
  if (!predicate) {
    logWarn(`[auth error]`, message)
    throw new Error(`unauthorized`)
  }
}

// throws notFound
export function assertFound(predicate: unknown, ...message: any): asserts predicate {
  assertBoom(predicate, message?.map((i: unknown) => String(i)).join(` `) || `not found`, `notFound`)
}

// throws badImplementation
export function assertWorks(predicate: unknown, message?: string): asserts predicate {
  assertBoom(predicate, message || `server error`, `badImplementation`)
}
